import React from 'react';
import ReactDOM from 'react-dom';
import { hashHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import 'rxjs/add/observable/concat';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/bufferWhen';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/ignoreElements';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/race';
import 'rxjs/add/operator/retryWhen';
import 'rxjs/add/operator/scan';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/take';
import 'moment/locale/es';
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-quill/dist/quill.snow.css';
import './assets/css/index.css';
import './assets/css/react-table.css';
import './assets/css/react-datepicker.css';
import Root from './containers/Root';
import configureStore from './store/configureStore';
import JWT from './shared/jwt';
import actionsAndConstants from './shared/actionsAndConstants';

const initialState = {};
const store = configureStore(initialState, hashHistory);
const history = syncHistoryWithStore(hashHistory, store);

const { app: { actions: appActions } } = actionsAndConstants;

const token = JWT.get();
if (token) {
  store.dispatch(appActions.verifyToken(token));
}

ReactDOM.render(<Root history={history} store={store} />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js